import React from 'react'

const Footer = () => {
return (
    <footer className="bg-navy-dark text-white">
        <div className="container mx-auto px-4 md:px-8 py-10 grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/10">
            <div className="pb-6 md:pb-0 md:pr-8">
                <p className="font-serif text-lg font-semibold">McLean Insurance Brokers & Risk Solutions Ltd.</p>
                <p className="mt-2 text-sm text-gray-300">Corner St. Thomas & 6th St, Belize City, Belize</p>
            </div>
            <div className="py-6 md:py-0 md:px-8">
                <p className="text-xs font-semibold tracking-widest text-gray-400 mb-2">Contact</p>
                <p className="text-sm text-gray-300">
                    Tel: <a href="tel:+5012230856" className="hover:text-gold-light">+501 223-0856</a>
                </p>
                <p className="text-sm text-gray-300">
                    WhatsApp: <a href="https://wa.me/5016237942" target="_blank" rel="noopener noreferrer" className="hover:text-gold-light">+501 623-7942</a>
                </p>
                <p className="text-sm text-gray-300">Email: info@mcleaninsurancebrokers.com</p>
            </div>
            <div className="pt-6 md:pt-0 md:pl-8">
                <p className="text-xs font-semibold tracking-widest text-gray-400 mb-2">Working Hours</p>
                <p className="text-sm text-gray-300">Monday - Friday: 08:00 - 17:00</p>
                <p className="text-sm text-gray-300">Saturday & Sunday: Closed</p>
            </div>
        </div>
        <div className="border-t border-white/10 px-4 md:px-8 py-4">
            <p className="text-gray-400 text-sm">
                © 2025 McLean Insurance Brokers & Risk Solutions Ltd. All rights reserved.
            </p>
        </div>
    </footer>
)
}

export default Footer
